import { Button, Col, Row } from "antd";
import { PlusOutlined } from "@ant-design/icons";

import { AdminMenuLayout } from "../../../shared/components";
import { WrapperCardCampaigns } from "./styled";
import { useCampaigns } from "../hooks";
import { TableCampaigns } from "./TableCampaigns";

export const Campaigns = () => {
  const { navigateCampaignsCreate } = useCampaigns();

  return (
    <AdminMenuLayout pageDescription="Campañas" title="Campañas">
      <WrapperCardCampaigns>
        <Row
          gutter={[8, 8]}
          style={{
            padding: "10px",
            width: "100%",
          }}
        >
          <Col
            span={24}
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <Button
              type="primary"
              shape="round"
              icon={<PlusOutlined />}
              size="large"
              onClick={navigateCampaignsCreate}
            >
              Agregar nueva campaña
            </Button>
          </Col>
        </Row>
        <TableCampaigns />
      </WrapperCardCampaigns>
    </AdminMenuLayout>
  );
};
